/**
 * 订单管理
 */
import { ORDERMANAGE } from '../types';

export default {
    name: `${ORDERMANAGE}`,
    path: '/orderManage',
    component: () => import(/* webpackChunkName: 'orderManage' */ '@/views/orderManage/'),
    redirect: { name: `${ORDERMANAGE}Index` },
    meta: {
        title: '订单管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ORDERMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'orderManage' */ '@/views/orderManage/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${ORDERMANAGE}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'orderManage' */ '@/views/orderManage/detail/Detail.vue'),
            permission: true,
        },
    ],
};
